var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInspectorAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12310_90455)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_12310_90455",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7.25,
    width: 8,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 12,
    y: 7.25,
    width: 8,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7539 8.53906L15.0508 10.0508L13.5391 10.7539C13.4453 10.8008 13.375 10.8945 13.375 11C13.375 11.1172 13.4453 11.2109 13.5391 11.2578L15.0508 11.9609L15.7539 13.4727C15.8008 13.5664 15.8945 13.625 16 13.625C16.1172 13.625 16.2109 13.5664 16.2578 13.4727L16.9609 11.9609L18.4727 11.2578C18.5664 11.2109 18.625 11.1172 18.625 11C18.625 10.8945 18.5664 10.8008 18.4727 10.7539L16.9609 10.0508L16.2578 8.53906C16.2109 8.44531 16.1172 8.375 16 8.375C15.8945 8.375 15.8008 8.44531 15.7539 8.53906Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7539 8.53906L15.0508 10.0508L13.5391 10.7539C13.4453 10.8008 13.375 10.8945 13.375 11C13.375 11.1172 13.4453 11.2109 13.5391 11.2578L15.0508 11.9609L15.7539 13.4727C15.8008 13.5664 15.8945 13.625 16 13.625C16.1172 13.625 16.2109 13.5664 16.2578 13.4727L16.9609 11.9609L18.4727 11.2578C18.5664 11.2109 18.625 11.1172 18.625 11C18.625 10.8945 18.5664 10.8008 18.4727 10.7539L16.9609 10.0508L16.2578 8.53906C16.2109 8.44531 16.1172 8.375 16 8.375C15.8945 8.375 15.8008 8.44531 15.7539 8.53906Z",
    fill: "url(#paint0_linear_12310_90455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7539 8.53906L15.3911 8.3703L15.3961 8.36018L15.7539 8.53906ZM15.0508 10.0508L15.4135 10.2195L15.3519 10.3519L15.2195 10.4135L15.0508 10.0508ZM13.5391 10.7539L13.3601 10.396L13.3704 10.3912L13.5391 10.7539ZM13.5391 11.2578L13.3703 11.6206L13.3602 11.6156L13.5391 11.2578ZM15.0508 11.9609L15.2195 11.5982L15.3519 11.6598L15.4135 11.7922L15.0508 11.9609ZM15.7539 13.4727L15.396 13.6516L15.3912 13.6413L15.7539 13.4727ZM16.2578 13.4727L16.6206 13.6414L16.6156 13.6515L16.2578 13.4727ZM16.9609 11.9609L16.5982 11.7922L16.6598 11.6598L16.7922 11.5982L16.9609 11.9609ZM18.4727 11.2578L18.6516 11.6157L18.6413 11.6205L18.4727 11.2578ZM18.4727 10.7539L18.6414 10.3911L18.6515 10.3961L18.4727 10.7539ZM16.9609 10.0508L16.7922 10.4135L16.6598 10.3519L16.5982 10.2195L16.9609 10.0508ZM16.2578 8.53906L16.6157 8.36011L16.6205 8.37037L16.2578 8.53906ZM15.7539 8.53906L16.1166 8.70775L15.4135 10.2195L15.0508 10.0508L14.6881 9.88209L15.3912 8.37037L15.7539 8.53906ZM15.0508 10.0508L15.2195 10.4135L13.7078 11.1166L13.5391 10.7539L13.3704 10.3912L14.8821 9.68809L15.0508 10.0508ZM13.5391 10.7539L13.7179 11.1117C13.7292 11.106 13.7408 11.0971 13.7512 11.0821C13.7622 11.0661 13.775 11.0379 13.775 11H13.375H12.975C12.975 10.7129 13.1602 10.4961 13.3602 10.3961L13.5391 10.7539ZM13.375 11H13.775C13.775 10.9761 13.7672 10.9521 13.7547 10.9334C13.7433 10.9162 13.7298 10.906 13.7179 10.9L13.5391 11.2578L13.3602 11.6156C13.1508 11.5109 12.975 11.2897 12.975 11H13.375ZM13.5391 11.2578L13.7078 10.8951L15.2195 11.5982L15.0508 11.9609L14.8821 12.3236L13.3704 11.6205L13.5391 11.2578ZM15.0508 11.9609L15.4135 11.7922L16.1166 13.304L15.7539 13.4727L15.3912 13.6413L14.6881 12.1296L15.0508 11.9609ZM15.7539 13.4727L16.1117 13.2938C16.0913 13.2531 16.0472 13.225 16 13.225V13.625V14.025C15.7418 14.025 15.5102 13.8797 15.3961 13.6515L15.7539 13.4727ZM16 13.625V13.225C15.991 13.225 15.9718 13.2276 15.9495 13.241C15.927 13.2544 15.91 13.2738 15.9 13.2938L16.2578 13.4727L16.6156 13.6515C16.4973 13.8881 16.2604 14.025 16 14.025V13.625ZM16.2578 13.4727L15.8951 13.304L16.5982 11.7922L16.9609 11.9609L17.3236 12.1296L16.6205 13.6413L16.2578 13.4727ZM16.9609 11.9609L16.7922 11.5982L18.304 10.8951L18.4727 11.2578L18.6413 11.6205L17.1296 12.3236L16.9609 11.9609ZM18.4727 11.2578L18.2938 10.9C18.2738 10.91 18.2544 10.927 18.241 10.9495C18.2276 10.9718 18.225 10.991 18.225 11H18.625H19.025C19.025 11.2604 18.8881 11.4973 18.6515 11.6156L18.4727 11.2578ZM18.625 11H18.225C18.225 11.0472 18.2531 11.0913 18.2938 11.1117L18.4727 10.7539L18.6515 10.3961C18.8797 10.5102 19.025 10.7418 19.025 11H18.625ZM18.4727 10.7539L18.304 11.1166L16.7922 10.4135L16.9609 10.0508L17.1296 9.68809L18.6413 10.3912L18.4727 10.7539ZM16.9609 10.0508L16.5982 10.2195L15.8951 8.70775L16.2578 8.53906L16.6205 8.37037L17.3236 9.88209L16.9609 10.0508ZM16.2578 8.53906L15.9 8.71795C15.906 8.72982 15.9162 8.74326 15.9334 8.7547C15.9521 8.76718 15.9761 8.775 16 8.775V8.375V7.975C16.2897 7.975 16.5109 8.15075 16.6156 8.36018L16.2578 8.53906ZM16 8.375V8.775C16.0379 8.775 16.0661 8.76217 16.0821 8.75116C16.0971 8.74077 16.106 8.72922 16.1117 8.71795L15.7539 8.53906L15.3961 8.36018C15.4961 8.16018 15.7129 7.975 16 7.975V8.375Z",
    fill: "white",
    mask: "url(#path-1-outside-1_12310_90455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76465 18.2496V6.94141L13.9458 15.1438H9.15994L8.87053 15.2285L5.76465 18.2496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1743 18.7227L9.63312 19.8027L6.32959 11.9745L8.92724 10.8804L12.1743 18.7227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04881 13.0366L7.74707 13.583L9.93267 18.79L11.2344 18.2436L9.04881 13.0366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4707 8.64258V16.5414L8.56717 14.5155L8.8707 14.4167H12.2307L6.4707 8.64258Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12310_90455",
    x: 4.35288,
    y: 6.94141,
    width: 17.0589,
    height: 15.6849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.705882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12310_90455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12310_90455",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12310_90455",
    x1: 17.7496,
    y1: 3.85831,
    x2: 13.878,
    y2: 3.85106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112057,
    stopColor: "#96C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374967,
    stopColor: "#B298FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598256,
    stopColor: "#D08DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769859,
    stopColor: "#FF6F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9159"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInspectorAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inspector-ai.95925c62a50db830e3b88bd2963e51e3.svg";